
import ReleaseTable from './components/releaseListTable.vue'
import FullLoading from '@/components/full_loading/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { ClueService } from '@/services'

const RelaseList = [
    { key: 0, name: '全部' },
    { key: 1, name: '审核中' },
    { key: 2, name: '已通过' },
    { key: 3, name: '不通过' }
]

@Component({
    name: 'release-list',
    components: {
        ReleaseTable,
        FullLoading,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType

    private pageSize = 50
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private curStatus = 0
    private StatusList = RelaseList
    private relaseList = []

    private mounted() {
        this.getRelaseList()
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getRelaseList)
    }

    private async getRelaseList() {
        this.isLoading = true
        const params: any = {
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        if (this.curStatus !== 0) {
            params.status = this.curStatus
        }
        const result = await ClueService.getReleaseList(params)
        this.isLoading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.relaseList = result.data.list
        }
    }

    private async onReleaseExamine(status: number, release: any) {
        const params = { id: release.id, status }
        const result = await ClueService.updateRelease(params)
        if (result.status === 200) {
            release.status = status
            this.$message({
                type: 'success',
                message: '修改成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }
}
